import { Heading, TextArea } from "grommet";
import React, { useEffect, useState } from "react";
import "../assets/styles/styles.scss";
import FormBlock from "../components/FormBlock";
import SelectInput from "../components/SelectInput";
import TextInput from "../components/TextInput";
import RadioInput from "../components/RadioInput";
import { NATIONALITIES, TITLES } from "../helpers/formLists";
import { useSelector } from "react-redux";
import { useForm, useWatch } from "react-hook-form";
import HorizontalRule from "../components/HorizontalRule";

function PersonalInformation({
  control,
  setValue,
  getValues,
  setError,
  clearErrors,
}) {
    const defaultValue = useSelector(
      (state) => state.form["does_the_candidate_reside_on_palm_beach_island_"],
//     (state) => state.form["visited_carriage"],
//      (state) => state.form["to_your_knowledge__is_the_candidate_known_to_other_members_of_carriage_house_"]
    );

    const [showPalmBeach, setShowPalmBeach] = useState(false);
    const [showVisited, setShowVisited] = useState(false);
    const [showKnow, setshowKnow] = useState(false);

    const pbSame = useWatch({
      control,
      name: "pb_same",
      defaultValue,
    });

    const knowMembers = useWatch({
      control,
      name: "to_your_knowledge__is_the_candidate_known_to_other_members_of_carriage_house_",
      defaultValue,
    });

    const residesInPalmBeachCheck = useWatch({
      control,
      name: "does_the_candidate_reside_on_palm_beach_island_",
      defaultValue,
    });

    const visitedCarriage = useWatch ({
      control,
      name: "has_the_candidate_visited_carriage_house_as_a_guest_before_",
      defaultValue,
    })

    useEffect(() => {
      if (knowMembers === "Yes") {
        setshowKnow(true);
      } else {
        setshowKnow(false);
      }
    }, [knowMembers]);

    useEffect(() => {
      if (visitedCarriage === "Yes") {
        setShowVisited(true);
      } else {
        setShowVisited(false);
      }
    }, [visitedCarriage]);

    useEffect(() => {
      if (residesInPalmBeachCheck === "Yes") {
        setShowPalmBeach(true);
      } else {
        setShowPalmBeach(false);
      }
    }, [residesInPalmBeachCheck]);


    return (
      <>
        <Heading fill level={2}>
          Personal Information
        </Heading>
        <FormBlock title={"What is his/her title and name?"}>
          <SelectInput
            control={control}
            name="title"
            label="Title"
            options={TITLES}
          />
          <TextInput control={control} name="firstname" label={"First Name"} />
          <TextInput control={control} name="lastname" label={"Last Name"} />
        </FormBlock>
    
        <FormBlock title={"What are his/her contact details?"}>
          <TextInput
            control={control}
            name="email"
            label={"Email Address"}
            validation={{ pattern: /^\S+@\S+$/i }}
          />
          <TextInput control={control} name="mobile" label={"Mobile Phone"} />
        </FormBlock>


        <FormBlock title={"What is his/her relationship status?"}>
          <RadioInput
            name="relationship_status"
            setValue={setValue}
            control={control}
            options={[
              "Single",
              "Married",
              "In a relationship",
              "Civil partnership",
              "Perfer not to say",
            ]}
            direction="column"
          />
        </FormBlock>

        <HorizontalRule />
          <FormBlock  title={"Does the candidate reside in Palm Beach?"}>
            <RadioInput
                name="does_the_candidate_reside_on_palm_beach_island_"
                setValue={setValue}
                control={control}
                options={["Yes", "No"]}
                direction="column"
              />
              {showPalmBeach && (
                  <RadioInput
                    name="reside_in_palmbeach"
                    setValue={setValue}
                    control={control}
                    options={[
                      "Seasonally",
                      "Year-round",
                    ]}
                    direction="column"
                  />
              )}
          </FormBlock>

          <HorizontalRule />
          <FormBlock  title={"Has the candidate visited Carriage House as a guest before?"}>
            <RadioInput
                name="has_the_candidate_visited_carriage_house_as_a_guest_before_"
                setValue={setValue}
                control={control}
                options={["Yes", "No"]}
                direction="column"
              />
              {showVisited && (
                <TextInput control={control} name="if_yes__approximately_how_many_times_might_they_have_visited_" label={"Approximately how many times might they have visited?"} />
              )}
          </FormBlock>
          
          <HorizontalRule />
          <FormBlock  title={"To your knowledge, is the candidate known to other Members of Carriage House?"}>
            <RadioInput
                name="to_your_knowledge__is_the_candidate_known_to_other_members_of_carriage_house_"
                setValue={setValue}
                control={control}
                options={["Yes", "No"]}
                direction="column"
              />
          </FormBlock>

          {showKnow && (
              <FormBlock  title={"Do you think other Members would be willing to support this candidate’s application?"}>
                <RadioInput
                        name="do_you_think_other_members_would_be_willing_to_support_this_candidate_s_application_"
                        setValue={setValue}
                        control={control}
                        options={["Yes", "No"]}
                        direction="column"
                      />  
              </FormBlock>
          )}

          <HorizontalRule />
          <Heading fill level={4} size="small">
          Please feel welcome to add any relevant comments that may support this candidate’s application
          </Heading>
          <TextArea  
            control={control} 
            name="revelant_info" 
            label={"Please feel welcome to add any relevant comments that may support this candidate’s application"}
            info="Please feel welcome to add any relevant comments that may support this candidate’s application"
            />
      </>
    );
}

export default PersonalInformation;
